export default "__VITE_ASSET__69fe6c90__"